<script>
    import { onMount } from 'svelte';

    import { user } from '../stores.js';

    user.useLocalStorage();

    onMount(() => setTimeout(() => {
        $user = {};
        window.location.href = `/`;
    }, 1));
</script>